"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ShortcutsWidget_1 = __importDefault(require("./ShortcutsWidget"));
exports.default = ShortcutsWidget_1.default;
